import { ReactNode, createContext, useState } from "react";

type PatientContextType = {
	patient: Patient;
	setPatient: (patient: Patient) => void;
};

type PatientContextProviderProps = {
	children: ReactNode;
};

export const PatientContext = createContext({} as PatientContextType);

export function PatientContextProvider({ children }: PatientContextProviderProps) {
	const [patient, setPatient] = useState<Patient>({} as Patient);

	return (
		<PatientContext.Provider value={{ patient, setPatient }}>
			{children}
		</PatientContext.Provider>
	);
}
